import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsString } from 'class-validator'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'

export class ListSubjectTypesQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({ type: 'string', description: 'Search by code or label' })
  @IsString()
  @IsOptional()
  search?: string
}
